import { Badge } from '@/components/ui/badge';
import {
  $selectedNode,
  closeNodeConfigurationDrawer,
} from '@/stores/workflowStore';
import { useStore } from '@nanostores/react';
import { X } from 'lucide-react';
import AiOutboundPhoneCallConfiguration from './NodeConfigurations/AiOutboundPhoneCallConfiguration';
import AnalyzerConfiguration from './NodeConfigurations/AnalyzerConfiguration';
import DataFlaggerNodeConfiguration from './NodeConfigurations/DataFlaggerConfiguration';
import DataIngestionConfiguration from './NodeConfigurations/DataIngestionConfiguration';
import EmailNotificationConfiguration from './NodeConfigurations/EmailNotificationConfiguration';
import SendSMSConfiguration from './NodeConfigurations/SendSMSConfiguration';
import SendWhatsAppMessageConfiguration from './NodeConfigurations/SendWhatsAppMessageConfiguration';
import SFTPDownloadConfiguration from './NodeConfigurations/SFTPDownloadConfiguration';
import SFTPUploadConfiguration from './NodeConfigurations/SFTPUploadConfiguration';
import TimerConfiguration from './NodeConfigurations/TimerConfiguration';

import { emitEventNodeConfigurationEventListener } from './utils/nodeConfigurationUtils';

interface Props {
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  nodeType:
    | 'EMAIL_NOTIFICATION'
    | 'ANALYZER'
    | 'EXECUTION_START'
    | 'EXECUTION_END'
    | 'DATA_INGESTION'
    | 'DATA_FLAGGER'
    | 'IF_ELSE_CONDITION'
    | 'SFTP_UPLOAD'
    | 'SFTP_DOWNLOAD'
    | 'TIMER'
    | 'SEND_SMS'
    | 'AI_OUTBOUND_PHONE_CALL'
    | 'SEND_WHATSAPP_MESSAGE'
    | null;
  setNodes: any;
  selectedNode: any;
  workflowId: string;
  setSelectedNode: React.Dispatch<React.SetStateAction<any>>;
  readOnly?: boolean;
}

export default function NodeConfigurationDrawer({
  // open,
  setOpen,
  // nodeType,
  setNodes,
  // selectedNode,
  workflowId,
  setSelectedNode,
  readOnly = false,
}: Props) {
  const selectedNode = useStore($selectedNode);
  const open = !!selectedNode;

  const nodeType = selectedNode?.type ?? null;
  const [
    allRequiredFieldsOfNodeConfigurationFilled,
    setAllRequiredFieldsOfNodeConfigurationFilled,
  ] = useState(true);

  // const [openUnsavedChangesDialog, setOpenUnsavedChangesDialog] =
  //   useState(false);
  return (
    <div
      style={{ height: 'calc(100vh - 190px)' }}
      className={`absolute right-6 top-16 min-w-[400px] max-w-[400px] rounded-lg bg-white p-4 pl-6 pr-6 ${!open && 'hidden'} z-10 shadow-lg`}
    >
      <div className="flex justify-between">
        <p className="text-sm font-semibold tracking-tight">
          Configure
          <Badge variant="outline" className="ml-1">
            {nodeType && nodeType.replace(/_/g, ' ')}
          </Badge>
        </p>
        <button
          type="button"
          onClick={() => {
            emitEventNodeConfigurationEventListener('confirmSaveChanges', {});
            closeNodeConfigurationDrawer();
          }}
        >
          <X className="h-4 w-4" />
        </button>
      </div>

      <div className="mt-4 h-[94%] w-[100%] bg-white overflow-y-auto pb-4">
        {nodeType === 'DATA_INGESTION' && (
          <DataIngestionConfiguration
            setNodes={setNodes}
            selectedNode={selectedNode}
            readOnly={readOnly}
          />
        )}

        {nodeType === 'ANALYZER' && (
          <AnalyzerConfiguration
            selectedNode={selectedNode}
            setNodes={setNodes}
            readOnly={readOnly}
          />
        )}

        {nodeType === 'DATA_FLAGGER' && (
          <DataFlaggerNodeConfiguration
            selectedNode={selectedNode}
            setNodes={setNodes}
            readOnly={readOnly}
          />
        )}

        {nodeType === 'SFTP_DOWNLOAD' && (
          <SFTPDownloadConfiguration
            selectedNode={selectedNode}
            setNodes={setNodes}
            readOnly={readOnly}
          />
        )}

        {nodeType === 'SFTP_UPLOAD' && (
          <SFTPUploadConfiguration
            selectedNode={selectedNode}
            setNodes={setNodes}
            workflowId={workflowId}
            readOnly={readOnly}
          />
        )}
        {nodeType === 'TIMER' && (
          <TimerConfiguration
            selectedNode={selectedNode}
            setNodes={setNodes}
            readOnly={readOnly}
            setAllRequiredFieldsOfNodeConfigurationFilled={
              setAllRequiredFieldsOfNodeConfigurationFilled
            }
          />
        )}

        {nodeType === 'EMAIL_NOTIFICATION' && (
          <EmailNotificationConfiguration
            selectedNode={selectedNode}
            setNodes={setNodes}
            readOnly={readOnly}
            setAllRequiredFieldsOfNodeConfigurationFilled={
              setAllRequiredFieldsOfNodeConfigurationFilled
            }
          />
        )}

        {nodeType === 'SEND_SMS' && (
          <SendSMSConfiguration
            selectedNode={selectedNode}
            setNodes={setNodes}
            readOnly={readOnly}
            setAllRequiredFieldsOfNodeConfigurationFilled={
              setAllRequiredFieldsOfNodeConfigurationFilled
            }
          />
        )}

        {nodeType === 'AI_OUTBOUND_PHONE_CALL' && (
          <AiOutboundPhoneCallConfiguration
            selectedNode={selectedNode}
            setNodes={setNodes}
            readOnly={readOnly}
            setAllRequiredFieldsOfNodeConfigurationFilled={
              setAllRequiredFieldsOfNodeConfigurationFilled
            }
          />
        )}

        {nodeType === 'SEND_WHATSAPP_MESSAGE' && (
          <SendWhatsAppMessageConfiguration
            selectedNode={selectedNode}
            setNodes={setNodes}
            readOnly={readOnly}
            setAllRequiredFieldsOfNodeConfigurationFilled={
              setAllRequiredFieldsOfNodeConfigurationFilled
            }
          />
        )}
      </div>

      {/* <Dialog open={openUnsavedChangesDialog} modal={true}>
        <DialogContent className="sm:max-w-[425px]">
          <DialogHeader>
            <DialogTitle>Save Changes</DialogTitle>
            <DialogDescription>
              You have some unsaved changes. Do you want to save them before
              leaving?
            </DialogDescription>
          </DialogHeader>
          <DialogFooter>
            <Button
              type="submit"
              variant="outline"
              size="sm"
              onClick={() => {
                emitEventNodeConfigurationEventListener('confirmSaveChanges', {
                  save: false,
                });
                setOpenUnsavedChangesDialog(false);
                closeNodeConfigurationDrawer();
              }}
            >
              Continue without saving
            </Button>
            <Button
              type="submit"
              size="sm"
              onClick={() => {
                emitEventNodeConfigurationEventListener('confirmSaveChanges', {
                  save: true,
                });
                setOpenUnsavedChangesDialog(false);
                closeNodeConfigurationDrawer();
              }}
            >
              Save changes
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog> */}
    </div>
  );
}
